module.exports = __webpack_public_path__ + "img/404.e2a8e452.png";